import { render, staticRenderFns } from "./IndexEmergency.vue?vue&type=template&id=1b47eb64&"
import script from "./IndexEmergency.vue?vue&type=script&lang=js&"
export * from "./IndexEmergency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports